import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/seminars';
const filter = (filter) => (filter) ? 'filter=' + filter : '';
const state = {
    seminars: [],
    seminar: null,
};
const getters = {
    seminars: (state) => state.seminars,
    seminar: (state) => state.seminar,
};
const actions = {
    async fetchSeminars({ commit }, search) {
        const response = await axios.get(API_URL + '?' + filter(search));
        commit('setSeminars', response.data.items);
    },
    async fetchSeminar({ commit }, id) {
        const response = await axios.get(API_URL + '/' + id + '/by-ref')        
        commit('setSeminar', response.data);
    }
};
const mutations = {
    setSeminars: (state, seminars) => state.seminars = seminars,
    setSeminar: (state, seminar) => state.seminar = seminar,
};

export default {
    state,
    getters,
    actions,
    mutations,
}